import { render, staticRenderFns } from "./RideBillingManage.vue?vue&type=template&id=16783aeb&scoped=true"
import script from "./RideBillingManage.vue?vue&type=script&lang=js"
export * from "./RideBillingManage.vue?vue&type=script&lang=js"
import style0 from "./RideBillingManage.vue?vue&type=style&index=0&id=16783aeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16783aeb",
  null
  
)

export default component.exports